import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icons, SvgLoading, TextFieldStateless, useFlags } from 'sarsaparilla';
import { ExpandableLocationSelector } from './locationPicker/ExpandableLocationSelector';
import useLocationDataSource from '../../src/hooks/useLocationDataSource';
import useIsLoggedInUserAConcessionaire from '../../src/hooks/useIsLoggedInUserAConcessionaire';

const propTypes = {
  id: PropTypes.string,
  collapsed: PropTypes.bool,
  locationSelect: PropTypes.func,
  allowAllLocationSelect: PropTypes.bool,
  showReservableLocations: PropTypes.bool,
  visibleLocationTypes: PropTypes.arrayOf(PropTypes.string),
  selectableLocationTypes: PropTypes.arrayOf(PropTypes.string),
  disableConcessionaireHierarchy: PropTypes.bool,
  allowHierarchyFillSelection: PropTypes.bool,
};

export default function LaunchLocationSelect({
  id,
  collapsed,
  locationSelect,
  allowAllLocationSelect,
  showReservableLocations,
  visibleLocationTypes,
  selectableLocationTypes,
  disableConcessionaireHierarchy = false,
  allowHierarchyFillSelection = false,
}) {
  const { internalAccountsLocationPickerUseInventoryService, locationPickerUseConcessionaireHierarchy } = useFlags();
  const [expansionMap, setExpansionMap] = React.useState({});
  const useFullHierarchy =
    useIsLoggedInUserAConcessionaire() && !disableConcessionaireHierarchy && locationPickerUseConcessionaireHierarchy;
  const { dataSource, searchValue, setSearchValue, fetchChildren, loading } = useLocationDataSource({
    useInventoryService: internalAccountsLocationPickerUseInventoryService,
    useFullHierarchy,
  });

  function onLocationExpandToggled(location, isExpanded) {
    if (isExpanded && !location.isHierarchyFill) {
      fetchChildren(location);
    }

    const updatedMap = Object.assign({}, expansionMap, {
      [location.id]: isExpanded,
    });

    setExpansionMap(updatedMap);
  }

  const classes = classNames({
    'launch-location-select-grid': true,
    collapsed,
  });
  const gridClasses = classNames({
    'location-picker-grid': true,
    'location-loading-data': loading,
  });

  return (
    <div className={classes}>
      <div className="location-picker-search">
        {collapsed || (
          <TextFieldStateless
            id={id || 'locationPickerSearchField'}
            className="location-picker-search-input"
            value={searchValue || ''}
            placeholder="Search Locations..."
            isLabelVisible={false}
            hasClearButton
            shouldFocusOnMount
            handleClearButtonClick={() => setSearchValue('')}
            onChange={(e) => setSearchValue(e.target.value)}
            iconElement={<Icons.IconSearch />}
            autoComplete="off"
            label="Location Search Input"
          />
        )}
      </div>

      <div className={gridClasses}>
        <ExpandableLocationSelector
          expansionMap={expansionMap}
          onLocationSelection={locationSelect}
          onLocationExpandChange={onLocationExpandToggled}
          maxDepth={10}
          allowAllLocationSelect={allowAllLocationSelect}
          showReservableLocations={showReservableLocations}
          visibleLocationTypes={visibleLocationTypes}
          allowHierarchyFillSelection={allowHierarchyFillSelection}
          selectableLocationTypes={selectableLocationTypes}
          dataSource={dataSource}
        />
        {loading && <SvgLoading size="larger" />}
      </div>
    </div>
  );
}

LaunchLocationSelect.propTypes = propTypes;
